export const SET_LOCATION_IDS = 'SET_LOCATION_IDS';
